import * as React from 'react';
export const bpostSvg = React.forwardRef(function bpostSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E20613',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'm8.7 13.35 7.43-2.25c-1.1 2.39-3.65 4.83-5.7 5.45-2.06.62-2.83-.81-1.73-3.2',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'M10.77 23.89c-6.17 1.87-8.48-2.44-5.17-9.6l2.14-.65c-2.17 4.69-.65 7.5 3.39 6.29 4.03-1.22 9.03-6.01 11.17-10.7l5.52-1.65c-3.26 7.13-10.9 14.44-17.05 16.3',
      }),
    ),
  );
});
bpostSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var bpost = {
  category: 'brand',
  colorable: false,
  name: 'bpost',
  svg: bpostSvg,
};
